import React from "react";
import {
  Box,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
} from "@chakra-ui/react";

import background from "../../assets/background.jpg";

import SidebarContent from "../SidebarContent";
import Navbar from "../Navbar";

interface Props {
  children: React.ReactNode;
}

export default function Layout(props: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box minH="100vh" bg={useColorModeValue("primary.100", "primary.900")}>
      <SidebarContent
        onClose={() => onClose}
        display={{ base: "none", md: "block" }}
      />
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        onOverlayClick={onClose}
        placement="left"
        returnFocusOnClose={false}
        size="full"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>

      {/* mobilenav */}
      <Navbar onOpen={onOpen} />

      <Box
        ml={{ base: 0, md: 60 }}
        p="4"
        backgroundImage={background}
        backgroundPosition="center"
        backgroundSize="cover"
        minHeight='100lvh'
      >
        {props.children}
      </Box>
    </Box>
  );
}
